<template>
  <div id="layout">
    <PC v-if="environment" />
    <WEB v-else/>
  </div>
</template>

<script>
export default {
  name: "layout",
  data() {
    return {
      environment: true // true PC, false WEB
    }
  },
  created() {
    
    let setRem = () => {
      if(document.documentElement.clientWidth > 768) {
        if(this.environment) return
        this.environment = true
        document.querySelector("html").removeAttribute("style")
      }else {
        if(!this.environment) return
        this.environment = false
      }
    }
    setRem()

    window.addEventListener("resize", () => {
      setRem()
    }, false)

  },
  components: {
    PC: () => import(/* webpackChunkName: "pc" */ '../pc/pc'),
    WEB: () => import(/* webpackChunkName: "web" */ '../web/web'),
  }
}
</script>
